import React from 'react';
import { BUY_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={BUY_ANCHOR} className={`block w-full text-center cursor-pointer px-3 py-3 sm:py-3.5 font-heading font-extrabold text-[13px] sm:text-base uppercase tracking-wide rounded-lg bg-cta text-white hover:bg-cta-dark transition-colors duration-200 border-b-4 border-[#A85510] active:border-b-0 active:translate-y-1 shadow-[0_4px_14px_0_rgba(230,126,34,0.4)] ${className}`} data-id="element-30" data-mp="2kyy4cjip6ka0">
      {children}
    </a>;
}